import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import ShellHeader from './ShellHeader';
import ShellBanner from './ShellBanner';
import ShellCaption from './ShellCaption';
import ShellNotifications from './ShellNotifications';
import ShellFooter from './ShellFooter';
import ShellMenu from './ShellMenu';
import MigrationBanner from 'src/containers/Login/MigrationBanner';

import navigationMap from './navigationMap';

import NotificationPopup from 'core/notifications/NotificationPopup';

import './MainLayout.scss';

@inject('settingsStore')
@observer
class MainLayout extends Component {
  componentWillMount() {
    const dataLoaded = navigationMap[this.props.pageId].dataLoaded;
    this.props.settingsStore.onPageMountingStart(this.props.pageId, dataLoaded);
  }

  render() {
    const isPageLoading = this.props.settingsStore.isPageLoading;
    const pageData = navigationMap[this.props.pageId];
    return (
      <div className={`shell-content ${isPageLoading ? 'show-' : 'hide-'}overlay ${this.props.className || ''}`}>
        <div className="overlay">
          <div className="overlay-content">
            <span className="spinner" />
          </div>
        </div>

        <ShellHeader className="fix-widthed" />
        <ShellBanner titleKey={pageData.titleKey} />
        <ShellNotifications />
        {this.props.pageId === 'login' && <MigrationBanner />}
        <ShellMenu />
        <ShellCaption captionKey={pageData.captionKey} />

        <div className="shell-body fix-widthed">{this.props.children}</div>
        <ShellFooter />
        <NotificationPopup />
      </div>
    );
  }

  componentDidMount() {
    this.props.settingsStore.onPageMountingEnd(this.props.pageId);
  }
}

export default MainLayout;



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/MainLayout.jsx